export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Files.json?hash=54a61ab350c803e766cd8ac3909f74e9";